import { render, staticRenderFns } from "./UserTraitList.vue?vue&type=template&id=f3b6c898&scoped=true&"
import script from "./UserTraitList.vue?vue&type=script&lang=js&"
export * from "./UserTraitList.vue?vue&type=script&lang=js&"
import style0 from "./UserTraitList.vue?vue&type=style&index=0&id=f3b6c898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b6c898",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VContainer,VList,VSwitch,VToolbar})
